module.exports = __webpack_public_path__ + "img/5-brought-together-communications.c5dc936a.png";